import { useMemo } from 'react'
import radicalsData from '../data/radicals.json'

const radicalsMap = radicalsData as Record<string, RadicalInfo>

interface RadicalInfo {
  glyph: string
  name?: string
  english?: string
  strokes?: number
  variants?: string[]
  pinyin?: string | string[]
  number?: number
}

// Lookup radical info by number and attach optional extra strokes
export function useRadical(
  radicalNumber?: number | null,
  extraStrokes?: number | null
) {
  return useMemo(() => {
    if (radicalNumber === null || radicalNumber === undefined) return null

    const radicalInfo = radicalsMap[radicalNumber.toString()]

    if (!radicalInfo) return null

    const pinyin =
      radicalInfo.pinyin === undefined
        ? undefined
        : Array.isArray(radicalInfo.pinyin)
          ? radicalInfo.pinyin
          : [radicalInfo.pinyin]

    return {
      number: radicalNumber,
      glyph: radicalInfo.glyph,
      // Keep backward compatibility if older data still uses `name`
      name: radicalInfo.name ?? radicalInfo.english,
      english: radicalInfo.english,
      strokes: radicalInfo.strokes,
      variants: radicalInfo.variants,
      pinyin,
      extraStrokes:
        extraStrokes !== null && extraStrokes !== undefined
          ? extraStrokes
          : undefined
    }
  }, [radicalNumber, extraStrokes])
}
